import { Component, OnInit  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from "../../components/common/utils/handleError.component";
import { RenunciaBeneficioSeguroService } from '../paginas_por_cliente/catolica_quito/renuncia-beneficio-seguro.service';
const swal = require("sweetalert2");

@Component({
    selector: 'cancelarRenunciaBeneficio',
    templateUrl: 'CancelarRenunciaBeneficio.template.html'
})

export class CancelarRenunciaBeneficioComponent implements OnInit{
    titular: number;
    cliente: number;
    ciudad: number;

    constructor(private route: ActivatedRoute, private renunciaBeneficioService: RenunciaBeneficioSeguroService, private router: Router, private handleError: HandleError) { }
    
    ngOnInit(){
        this.titular = 0;
        this.cliente = 0;
        this.ciudad=0;
        this.route.params.subscribe(params => {
            this.titular = params['titular'];
            this.cliente = params['cliente'];
            this.ciudad = params['ciudad'];
            if (this.titular == 0 && this.cliente == 0&& this.ciudad == 0) {
                this.router.navigate(["/error404"]);
            } else {
                this.renunciaBeneficioService.AnulacionRenunciarBeneficioMedico(this.titular,this.cliente,this.ciudad).subscribe(result => {
                    var resultado = result;
                    var varGeneral = this;
                    if(resultado == true){
                        swal({
                            title: 'OK',
                            text: "Se ha reactivado correctamente su beneficio de seguro médico.",
                            type: 'success'
                        }).then((function(){
                            window.location.href = "http://www.tecniseguros.com.ec";
                        }).bind(this));
                    }
                },
                    erorr => {
                        swal({
                            title: 'Lo sentimos',
                            text: "Ha ocurrido un error, por favor intentelo más tarde",
                            type: 'error'
                        }).then((function(){
                            window.location.href = "http://www.tecniseguros.com.ec";
                        }).bind(this));
                    });
                console.log("Cancelacion Renuncia")
            }
        });
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/CancelarRenunciaBeneficio.component.ts